import React from 'react'
import Wordpress2016 from 'typography-theme-wordpress-2016'

import { scale, rhythm } from '../utils/typography'

class Footer extends React.Component {
  getDateRange() {
    const startYear = 2018
    const currentYear = new Date().getFullYear()
    return startYear === currentYear ? startYear : `${startYear}–${currentYear}`
  }

  render() {
    return (
      <footer
        style={{
          backgroundColor: Wordpress2016.bodyColor,
          color: 'white',
          ...scale(-1 / 2),
          paddingTop: 5,
        }}
      >
        <div
          style={{
            maxWidth: rhythm(24),
            margin: '0 auto',
            padding: `${rhythm(1 / 4)} ${rhythm(3 / 4)} ${rhythm(2)}`,
            lineHeight: 'initial',
          }}
        >
          <div>
            © {this.getDateRange()} David Davidson |{' '}
            <a
              href="mailto:daviddavidson.1988@gmail.com"
              target="_blank"
              style={{
                color: 'white',
              }}
            >
              daviddavidson.1988@gmail.com
            </a>{' '}
            |{' '}
            <a
              href="/rss.xml"
              target="_blank"
              style={{
                color: 'white',
              }}
            >
              RSS
            </a>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js